import { useContext } from "react";
import { StockItemContext } from "../contexts/stockItemContext";

const useStockItemContext = () => useContext(StockItemContext);

export default useStockItemContext;
